module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/public-sciences-1-ed560099efe967f01e6a9f5318deb33b.png";